"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _urlCatalog = _interopRequireDefault(require("@angi/url-catalog"));

var _angieslistAppPlatform = require("angieslist-app-platform");

var _headerAnalytics = _interopRequireDefault(require("./headerAnalytics"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var activityLocation = 'Ads Auth Header';

var AngiAdsSubNavItems = function AngiAdsSubNavItems(_ref) {
  var currentSubNav = _ref.currentSubNav,
      hasBmt = _ref.hasBmt,
      highlightSubNav = _ref.highlightSubNav,
      isAdmin = _ref.isAdmin,
      isAdvertiser = _ref.isAdvertiser,
      spId = _ref.spId,
      subNavStyling = _ref.subNavStyling;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "unified-header-sub-nav--ads-pro"
  }, currentSubNav === 'reviews' ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "All reviews",
    href: _urlCatalog["default"].office.ads.reviews(spId),
    id: "unified-header-sub-nav--all-reviews",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('allReviews');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('allReviews')
  }, "All reviews"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Request reviews",
    href: _urlCatalog["default"].office.ads.requestReviews(spId),
    id: "unified-header-sub-nav--request-reviews",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('requestReviews');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('requestReviews')
  }, "Request reviews")))] : currentSubNav === 'myBusiness' ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Settings",
    href: _urlCatalog["default"].office.ads.spProfile.edit(spId),
    id: "unified-header-sub-nav--settings",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('settings');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('settings')
  }, "Business profile"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Coverage area",
    href: _urlCatalog["default"].office.ads.spProfile.serviceAreas(spId),
    id: "unified-header-sub-nav--coverage-area",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('coverageArea');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('coverageArea')
  }, "Service areas"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "2"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Services",
    href: _urlCatalog["default"].office.ads.manageCategories(spId),
    id: "unified-header-sub-nav--services",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('services');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('services')
  }, "Service categories"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "3"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Associates",
    href: _urlCatalog["default"].office.ads.associates(spId),
    id: "unified-header-sub-nav--associates",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('associates');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('associates')
  }, "Associates"))), hasBmt ? [/*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "4-0"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Customers",
    href: _urlCatalog["default"].office.bmt.customers(spId),
    id: "unified-header-sub-nav--bmt-customers",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('customers');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('customers')
  }, "Customers"))), /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "4-1"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Price list",
    href: _urlCatalog["default"].office.bmt.priceList(spId),
    id: "unified-header-sub-nav--bmt-pricelist",
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('priceList');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('priceList')
  }, "Price list")))] : null, isAdmin && isAdvertiser ? /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "5"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Manage agreements",
    id: "unified-header-sub-nav--agreements",
    href: _urlCatalog["default"].office.ads.paymentMethod(spId),
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('agreements');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('agreements')
  }, "Manage agreements"))) : null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, {
    key: "6"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    "data-track-activity-location": activityLocation,
    "data-track-description": "Connected numbers",
    id: "unified-header-sub-nav--connected-numbers",
    href: _urlCatalog["default"].office.ads.connectedNumbers(spId),
    onMouseEnter: function onMouseEnter() {
      return highlightSubNav('connectedNumbers');
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: subNavStyling('connectedNumbers')
  }, "Connected numbers")))] : null);
};

var _default = (0, _compose["default"])((0, _angieslistAppPlatform.analytics)({
  ruleset: _headerAnalytics["default"]
}), // eslint-disable-next-line no-unused-vars
(0, _reactRedux.connect)(function (state, props) {
  return {};
}, _objectSpread({}, _angieslistAppPlatform.analyticsActions)), _pure["default"])(AngiAdsSubNavItems);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/v1/header/angiAdsSubNavItems.js
// module id = 3670
// module chunks = 25